module.exports = __webpack_public_path__ + "static/media/detective.4ef1af8f.png";